module.exports = __webpack_public_path__ + "static/2two-c0726845191ae7a47314443043d18a1f.jpg";